import AxiosService from "./axiosServices";

// const axiosService = new AxiosService();

const BatchesService = {
  getBatchData: (requestData) => {
    return AxiosService.Get("api/cam/srm/batch-list/", {
      params: requestData,
    });
  },
  getPartialBatchData: (requestData) => {
    return AxiosService.Get("api/cam/srm/partial-batches/", {
      params: requestData,
    });
  },
  exportPartialBatches: (unitOperationIds) => {
    return AxiosService.Get("api/cam/srm/partial-batches/export/", {
      params: { unit_op_ids: unitOperationIds.join(",") },
    });
  },
  getPartialBatchesExportStatus: (taskId) => {
    return AxiosService.Get(
      `api/cam/srm/partial-batches/export/status/${taskId}/`,
    );
  },

  // createBatchAPI: async (batchData) => {
  //   const response = await AxiosService.Post("api/cam/srm/batches/", batchData);
  //   return response.data;
  // },

    fetchBatchMetaData: (requestData) => {
    return AxiosService.Get("api/cam/srm/batch_metadata/", {
      params: requestData,
    });
  },

    downloadBatchesData: (requestData) => {
    return AxiosService.Post("api/cam/srm/batch/management/export-batches/", requestData);
  },

    getProductMetaList: () => {
    return AxiosService.Get("api/cam/pc/get-products/");
  },

    getSiteMetaList: (requestData) => {
    return AxiosService.Get("api/cam/pc/get-sites/" , {
      params: requestData,
    });
  },

    getUnitOperationMetaList: (requestData) => {
    return AxiosService.Get("api/cam/pc/get-steps/",  {
      params: requestData,
    });
  },

    exportAllBatches: (requestData) => {
    return AxiosService.Post("api/cam/pc/export-batches/",requestData);
  },

    getAllBatches: (requestData) => {
    return AxiosService.Get("api/cam/pc/get-batches/", {
      params: requestData,
    });
  },
    getBatchesToDownload: (requestData) => {
    return AxiosService.Get("api/cam/pc/get-batches/", {
      params: requestData,
    });
  },

    getAllBatcheStatus: (requestData) => {
    return AxiosService.Get(`api/cam/pc/export-status/${requestData}/`);
  },

    getBatchDetails: (requestData) => {
    return AxiosService.Get("api/cam/srm/batch/management/batch-detail/", {
      params: requestData,
    });
  },

};

export default BatchesService;
